import None from './None.js';
import Some from './Some.js';
export default function fromPredicate(predicate) {
    return function (value) { return (predicate(value) ? Some(value) : None); };
}
//# sourceMappingURL=fromPredicate.js.map